<mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <!-- Position Column -->
  <ng-container matColumnDef="store">
    <mat-header-cell *matHeaderCellDef> Store. </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.store }} </mat-cell>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="pending">
    <mat-header-cell *matHeaderCellDef> Pending </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.pending }} </mat-cell>
  </ng-container>

  <!-- Weight Column -->
  <ng-container matColumnDef="overdue">
    <mat-header-cell *matHeaderCellDef> Overdue </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.overdue }} </mat-cell>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="late">
    <mat-header-cell *matHeaderCellDef> Late </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.late }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="total">
    <mat-header-cell *matHeaderCellDef> Total </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ element.total }} </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>

<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
